module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4gUTDRInyDIxwwAAAIZJREFUSMfNVDESgCAMK3ksgw6+xUG/6qB3uHOgWNJKJwaSNKElXOchmprmJYmI7NsaNHj0iOZnU2GtEMUxoxmwBL6KwztiatSa5sAmbL0Li4hbMNSoaW/cM1BvWFhO8RPHWFEzd7bGBeuPosY5RtQWbmvc8BAtafwbtYfb3HWIMaZh9tijbvUARBg2VOopAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/heijiantou_geren_icon.png
// module id = 179
// module chunks = 0